export const debounce = (func, wait, immediate) => {
  var timeout;
  return function () {
    var context = this,
      args = arguments,
      later = function () {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      },
      callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
};

export const convertToClass = (string) => {
  if (string === null || string === undefined || typeof string !== "string") {
    return "";
  }

  return string
    .trim()
    .replace(/[ &/\\#,+()$~%.'":*?<>{}]/g, "-")
    .toLowerCase();
};

export const isPortrait = () => {
  if (window.innerHeight > window.innerWidth) {
    return true;
  }

  return false;
};
